import { createLazyComponent, LazyModule, type LazyComponent } from "owa-bundling";
import type * as lazyIndex from "./lazyIndex";
import type { StatusBarRemindersProps } from "./components/StatusBarReminders";
import type { StatusBarZoomProps } from "./components/StatusBarZoom";
import type { StatusBarViewShortcutsProps } from "./components/StatusBarViewShortcuts";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "StatusBarItems" */ "./lazyIndex"), { name: "StatusBarItems" });

export const LazyStatusBarReminders: LazyComponent<StatusBarRemindersProps, unknown, void> = createLazyComponent(lazyModule, m => m.StatusBarReminders);

export const LazyStatusBarZoom: LazyComponent<StatusBarZoomProps, unknown, void> = createLazyComponent(lazyModule, m => m.StatusBarZoom);

export const LazyStatusBarViewShortcuts: LazyComponent<StatusBarViewShortcutsProps, unknown, void> = createLazyComponent(lazyModule, m => m.StatusBarViewShortcuts);
